import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';

/**
 * ラジオボタンの選択を外す
 * @example
 * <label class="css_radio_button js-ripple" data-radio_uncheck>
 * <input type="radio" name="test100">
 * <span>￥1,000 OFF</span>
 * </label><!-- /block_radio_button_v -->
 */
export default class RadioUncheckClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'RadioUncheckClass';

    this.target = _target;
    this.onCheckListener = this.onCheck.bind(this);
  }

  onCreate() {
    super.onCreate();
    this.target.on('click', this.onCheckListener).off('change', this.onCheckListener);
  }

  onCheck(e) {
    e.preventDefault();

    let t = $('input', $(e.currentTarget));
    if (t.length < 1) {
      const id = $(e.currentTarget).attr('for');
      t = $('#' + id);
    }
    const flag = !t.prop('checked');
    t.prop('checked', flag);
  }
}
